module.exports = __webpack_public_path__ + "static/media/lost.a84ca543.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/static/lost.jpeg
// module id = 524
// module chunks = 0